import type { CardSurvey } from '../types';

export type SurveyPayload = unknown;

/**
 * New format: card-v1 with questions[] and paths[]
 */
export function isNewFormat(payload: SurveyPayload): payload is CardSurvey {
  return (
    payload != null &&
    typeof payload === 'object' &&
    'format' in (payload as object) &&
    (payload as { format?: string }).format === 'card-v1'
  );
}

/**
 * Old format: flow with nodes and edges (may also have top-level "survey" array)
 */
export function isOldFlowFormat(payload: SurveyPayload): payload is { nodes: unknown[]; edges: unknown[] } {
  const o = payload as Record<string, unknown> | null;
  return (
    o != null &&
    typeof o === 'object' &&
    Array.isArray(o.nodes) &&
    Array.isArray(o.edges)
  );
}

/**
 * Old format: legacy with "survey" array only
 */
export function isOldLegacyArrayFormat(payload: SurveyPayload): boolean {
  const o = payload as Record<string, unknown> | null;
  return (
    o != null &&
    typeof o === 'object' &&
    'survey' in o &&
    Array.isArray((o as { survey?: unknown }).survey)
  );
}

/**
 * Old format: plain array of survey items
 */
export function isOldPlainArrayFormat(payload: SurveyPayload): payload is unknown[] {
  return Array.isArray(payload) && payload.length > 0;
}

/**
 * True if payload is any old format (not card-v1)
 */
export function isOldFormat(payload: SurveyPayload): boolean {
  if (isNewFormat(payload)) return false;
  return isOldFlowFormat(payload) || isOldLegacyArrayFormat(payload) || isOldPlainArrayFormat(payload);
}
